module.exports = __webpack_public_path__ + "static/express.b5a23e7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/express.svg
// module id = 544
// module chunks = 35783957827783